import React from "react";
import { Box, Typography } from "@mui/material";
import { AGENT_FORM_FIELD_MAX } from "../../utils/agentFormLayout";

/**
 * Seção do formulário — título limpo (sem repetir número da barra de etapas).
 */
export default function AgentFormSection({
  id,
  title,
  hint,
  children,
  hidden = false,
  badge,
  fullWidth = false,
}) {
  if (hidden) return null;

  return (
    <Box
      id={`agent-form-section-${id}`}
      component="section"
      sx={{
        scrollMarginTop: 120,
        py: { xs: 2, md: 2.25 },
        borderBottom: 1,
        borderColor: "divider",
        "&:last-of-type": { borderBottom: 0 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap",
          gap: 1,
          mb: hint ? 0.5 : 1.5,
          pl: 1.5,
          borderLeft: 3,
          borderColor: "primary.main",
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3, whiteSpace: "nowrap" }}>
          {title}
        </Typography>
        {badge}
      </Box>
      {hint && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.75, pl: 1.5, lineHeight: 1.45 }}>
          {hint}
        </Typography>
      )}
      <Box
        sx={{
          pl: fullWidth ? 0 : { xs: 0, sm: 1.5 },
          maxWidth: fullWidth ? "none" : AGENT_FORM_FIELD_MAX,
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
